import { render, staticRenderFns } from "./pdfView.vue?vue&type=template&id=da927820&scoped=true"
import script from "./pdfView.vue?vue&type=script&lang=js"
export * from "./pdfView.vue?vue&type=script&lang=js"
import style0 from "./pdfView.vue?vue&type=style&index=0&id=da927820&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da927820",
  null
  
)

export default component.exports